import { Button, ButtonProps, styled, Theme } from "@mui/material";

export const BybButtonBase = styled((props: ButtonProps) => <Button {...props} disableRipple disableFocusRipple disableTouchRipple />)(
  ({ theme }) => ({
    textTransform: "none",
    borderRadius: theme.spacing(1.5),
  })
);

export const primaryOutline = (theme: Theme) => ({
  boxShadow: `0 0 0 2px ${theme.palette.dsPrimary.v300}`,
  ":hover": {
    boxShadow: `0 0 0 3px ${theme.palette.dsPrimary.v300}!important`,
  },
  "&.Mui-focusVisible": {
    boxShadow: `0 0 0 3px ${theme.palette.dsPrimary.v300}!important`,
  },
});

export const surfaceV100Background = (theme: Theme) => ({
  backgroundColor: theme.palette.dsSurface.v100,
  "&:hover, &:focus, &:focus-visible, &:active": {
    backgroundColor: theme.palette.dsSurface.v200,
  },
});
